if (!customElements.get("nss-clinical-studies-value-prop")) {
    class NSSClinicalStudiesValueProp extends HTMLElement {
        constructor() {
            super();

            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) return;

                        const progress = this.querySelector(
                            '.js-nss-clinical-studies-value-prop-progress'
                        );

                        if (progress) {
                            const width = progress.dataset.width;

                            if (width) {
                                progress.style.width = `${width}%`;
                            }
                        }

                        this.observer.unobserve(this);
                    });
                },
                {
                    root: null,
                    threshold: 0.3
                }
            );
        }

        connectedCallback() {
            this.observer.observe(this);
        }

        disconnectedCallback() {
            this.observer.disconnect();
        }
    }

    customElements.define(
        'nss-clinical-studies-value-prop',
        NSSClinicalStudiesValueProp
    );

}